// SolicitudAccesoSection.js — Sección `solicitud_acceso`.
//
// No ocupa sitio en la página: deja listo el formulario emergente de
// prerregistro (SolicitudAccesoModal) y lo abre cuando se hace clic en
// cualquier elemento que lo pida, esté en la sección que esté (un bloque HTML,
// el pie de página…):
//
//   · clase `active_preregistre` (la del sitio original de LAAC) o `abrir-solicitud`
//   · atributo `data-solicitud-acceso`
//   · enlace `href="#solicitar-acceso"`
//   · el selector que se escriba en `config.selector`
//
// También se abre al llegar con `#solicitar-acceso` en la dirección y con el
// evento `abrirSolicitudAcceso()` (para botones de otros componentes).
// Opcionalmente pinta su propio botón (`config.texto_boton`).
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import SolicitudAccesoModal from '../SolicitudAccesoModal';

export const EVENTO_SOLICITUD = 'mentoria:solicitud-acceso';
export const SELECTOR_DEFECTO = '.active_preregistre, .abrir-solicitud, [data-solicitud-acceso], a[href="#solicitar-acceso"]';

// `modo: 'registro'` abre el mismo formulario como registro de la web (crea la
// cuenta al instante), p. ej. el botón «Crear cuenta» de Restablecer.
export const abrirSolicitudAcceso = (opciones = {}) =>
  window.dispatchEvent(new CustomEvent(EVENTO_SOLICITUD, { detail: opciones }));

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  padding: ${p => p.$padding || '1.5rem 1rem'};
`;

const Boton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 16px 24px;
  border: none;
  border-radius: 11px;
  background: ${p => p.$fondo || 'linear-gradient(90deg, #c026d3 30%, #9333ea 70%, #7e22ce 100%)'};
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: inherit;
  letter-spacing: .5px;
  cursor: pointer;
  transition: all .3s ease;
  &:hover { box-shadow: 0 8px 20px rgb(168 85 247 / .3); transform: translateY(-5px); }
`;

const SolicitudAccesoSection = ({ config = {}, proyecto, tl }) => {
  const [abierto, setAbierto] = useState(false);
  const [modo, setModo] = useState('solicitud');
  const abrir = useCallback((e) => {
    setModo(e?.detail?.modo === 'registro' ? 'registro' : 'solicitud');
    setAbierto(true);
  }, []);
  const cerrar = useCallback(() => setAbierto(false), []);

  useEffect(() => {
    let selector = SELECTOR_DEFECTO;
    if (config.selector) {
      // Un selector mal escrito en el admin no debe romper los de siempre.
      try { document.querySelector(config.selector); selector = `${SELECTOR_DEFECTO}, ${config.selector}`; } catch (e) { /* se ignora */ }
    }
    const onClick = (e) => {
      const el = e.target instanceof Element ? e.target.closest(selector) : null;
      if (!el) return;
      e.preventDefault();
      abrir(null);
    };
    // Fase de captura: gana a los enlaces vacíos (`href=""`) que recargarían la página.
    document.addEventListener('click', onClick, true);
    window.addEventListener(EVENTO_SOLICITUD, abrir);
    if (window.location.hash === '#solicitar-acceso') abrir(null);
    return () => {
      document.removeEventListener('click', onClick, true);
      window.removeEventListener(EVENTO_SOLICITUD, abrir);
    };
  }, [config.selector, abrir]);

  const textoBoton = tl ? tl(config.texto_boton, '') : config.texto_boton;

  return (
    <>
      {textoBoton && (
        <Wrap $padding={config.padding}>
          <Boton type="button" $fondo={config.fondo_boton} onClick={() => abrir(null)}>{textoBoton}</Boton>
        </Wrap>
      )}
      {abierto && <SolicitudAccesoModal config={config} proyecto={proyecto} onClose={cerrar} tl={tl} modo={modo} />}
    </>
  );
};

export default SolicitudAccesoSection;
